/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import findIndex from 'lodash/findIndex';
import moment from 'moment';
import update from 'immutability-helper';
import { v4 as uuidv4 } from 'uuid';

import { ADD_ERROR, CLEAR_ERROR } from 'actionCreators';

const initialState = [];

export const applicationErrorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ERROR: {
      return update(state, {
        $push: [{ ...action.error, id: uuidv4(), timestamp: moment().valueOf() }],
      });
    }
    case CLEAR_ERROR: {
      return update(state, {
        $splice: [[findIndex(state, { id: action.error.id }), 1]],
      });
    }
    default:
      return state;
  }
};

export const getApplicationErrors = state => state.applicationErrors;
